import React, { useState, useEffect, use } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useParams } from "react-router-dom";
import {
  createSubscription,
  cancelSubscription,
  resumeSubscription,
  getSubscription,
  changePlan,
  getProductList
} from "../../apis/apiList/stripeApi";
import { useApp } from "../../context/AppContext";
import { useMessage } from "../../context/MessageContext";
import Plans from "./Plans";
import Checkout from "./Checkout";
import ManageSubscription from "./ManageSubscription";
import { getCustomerBillingHistory } from "../../apis/apiList/billingHistoryApi";
import { products } from "../../data/products";

// const monthlyPriceId = process.env.REACT_APP_MONTHLY_PLAN_ID;
// const quarterlyPriceId = process.env.REACT_APP_QUARTERLY_PLAN_ID;
// const annualPriceId = process.env.REACT_APP_YEARLY_PLAN_ID;
// const twoVideoAnuualPriceId = process.env.REACT_APP_YEARLY_TWO_VIDEO_PLAN;
// const weekPlan = process.env.REACT_APP_WEEK_PLAN;
// const biweeklyPlan = process.env.REACT_APP_BI_WEEK_PLAN;

// let products =[
//   {
//     id: monthlyPriceId,
//     name: 'Pay As You Go',
//     description: 'A convenient option that allows you to produce videos on a monthly basis while paying as you go. Enjoy the same professional Snapshot Video experience without the need for an annual commitment.',
//     type: 'service',
//     unit_amount: 100000,
//     interval: 'month',
//   },
//   {
//     id: quarterlyPriceId,
//     name: 'Quarterly – 4 Videos/yr',
//     description: 'Receive a fresh new video every quarter to highlight key initiatives, showcase important updates, and keep your members and industry engaged year-round.',
//     type: 'service',
//     unit_amount: 300000,
//     interval: 'year',
//   },
//   {
//     id: annualPriceId,
//     name: 'Monthly - 12 Videos/yr',
//     description: 'Designed for organizations that distribute a newsletter every month. Each issue is transformed into a polished video, ensuring your members receive consistent, engaging updates 12 times a year.',
//     type: 'service',
//     unit_amount: 900000,
//     interval: 'year',
//   },
//   // {
//   //   id: twoVideoAnuualPriceId,
//   //   name: '24 Snapshots - Annual Subscription',
//   //   description: 'This plan is best for yearly subscribers. You will get 24 videos for the year.',
//   //   type: 'service',
//   //   unit_amount: 1800000,
//   //   interval: 'year',
//   // },
//   {
//     id: biweeklyPlan,
//     name: 'Biweekly – 26 Videos/yr',
//     description: 'Best for associations that send a newsletter every other week. With 26 videos annually, this option mirrors your publishing schedule and ensures members receive timely, engaging updates all year long.',
//     type: 'service',
//     unit_amount: 1950000,
//     interval: 'year',
//   },
//   {
//     id: weekPlan,
//     name: 'Weekly – 52 Videos/yr',
//     description: 'Ideal for organizations that send a newsletter every week. Each edition is repurposed into a professional Snapshot Video, 52 per year, delivering timely updates that match your communication rhythm.',
//     type: 'service',
//     unit_amount: 3900000,
//     interval: 'year',
//   },
// ]

function SubscribeForm({ selectedOrgId }) {
  const { userDetails } = useApp();
  const { showMessage } = useMessage();
  const { id: orgId } = useParams();

  const stripe = useStripe();
  const elements = useElements();

  const [step, setStep] = useState("selectPlan"); // "selectPlan" | "checkout" | "manage"
  const [plan, setPlan] = useState("");
  const [name, setName] = useState(
    `${userDetails.firstName} ${userDetails.lastName}` || ""
  );
  const [email, setEmail] = useState(userDetails.email || "");
  const [loading, setLoading] = useState(false);

  const [subscription, setSubscription] = useState(null);
  const [productList, setProductList] = useState(products);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [billingHistory, setBillingHistory] = useState([]);
  const [refreshFlag, setRefreshFlag] = useState(false);

  // useEffect(() => {
  //   async function fetchProducts() {
  //     const productList = await getProductList();
  //     console.log("productList", productList);
  //     // setProductList(productList.products)
      
  //   }
  //   fetchProducts();
  // }, []);
  
  async function fetchBillingHistory() {
    const res = await getCustomerBillingHistory(orgId, {
      headers: {
        "Content-Type": "application/json",
        "x-access-token": userDetails.jwtToken,
      },
    });
    console.log("billing history without dependency", res);
    setBillingHistory(res.billingHistory)
  }

  useEffect(() => {
    fetchBillingHistory();
  }, [orgId]);


  // Fetch current subscription
  useEffect(() => {
    if (!selectedOrgId) return;
    (async () => {
      try {
        const res = await getSubscription(selectedOrgId, {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": userDetails.jwtToken,
          },
        });
        if (res.subscription) {
          setSubscription(res.subscription);
          setPlan(res.subscription.plan);
          setStep("manage");
        }
      } catch (err) {
        console.error("fetch subscription failed:", err);
      }
    })();
  }, [selectedOrgId, userDetails]);

  const validateEmail = (email) => {
    const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    return EMAIL_REGEX.test(String(email).toLowerCase());
  }

  // ---------------- Handle Subscribe ----------------
  const handleSubscribe = async () => {
    if (!stripe || !elements) return;
    if (!name || !email) {
      showMessage("Name and Email are required", "error");
      return;
    }


    if (!validateEmail(email)) {
      showMessage("Please enter a valid email address.", "error");
      return;
    }
    setLoading(true);
    try {
      const cardElement = elements.getElement(CardElement);
      const pmResult = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
        billing_details: { email, name },
      });
      if (pmResult.error) {
        
        showMessage(pmResult.error.message, "error");
        return;
      }

      // const priceId = plan === "monthly" ? monthlyPriceId : annualPriceId;
      const priceId = selectedProduct.id;
      console.log("priceId", selectedProduct);
      
      const subRes = await createSubscription(
        {
          organizationId: selectedOrgId,
          priceId,
          paymentMethodId: pmResult.paymentMethod.id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": userDetails.jwtToken,
          },
        }
      );

      const { clientSecret, status, subscription: subData } = subRes;

      if (clientSecret && status === "requires_action") {
        const { error: confirmError } = await stripe.confirmCardPayment(
          clientSecret
        );
        if (confirmError) {
          showMessage(confirmError.message, "error");
          return;
        }
      }

      setSubscription(subData);
      fetchBillingHistory();
      setStep("manage");
      showMessage("Subscription successful!", "success");
    } catch (err) {
      console.error(err);
      showMessage(
        err.response?.data?.error || "Subscription failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // ---------------- Handle Cancel ----------------
  const handleCancel = async () => {
    try {
      const res = await cancelSubscription(
        { organizationId: selectedOrgId },
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": userDetails.jwtToken,
          },
        }
      );
      setSubscription(res.subscription);
      fetchBillingHistory();
      showMessage("Subscription canceled.", "info");
    } catch (err) {
      showMessage("Failed to cancel subscription", "error");
    }
  };

  // ---------------- Handle Resume ----------------
  const handleResume = async () => {
    try {
      const res = await resumeSubscription(
        { organizationId: selectedOrgId },
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": userDetails.jwtToken,
          },
        }
      );
      setSubscription(res.subscription);
      fetchBillingHistory();
      showMessage("Subscription resumed.", "success");
    } catch (err) {
      showMessage("Failed to resume subscription", "error");
    }
  };

  // ---------------- Handle Change Plan ----------------
  const handleChangePlan = async (priceId) => {
    try {
      // const toPlan = plan === "monthly" ? "yearly" : "monthly";
      const toPlan = priceId;
      const res = await changePlan(
        { organizationId: selectedOrgId, toPlan },
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": userDetails.jwtToken,
          },
        }
      );
      fetchBillingHistory();
      setSubscription(res.subscription);
      setPlan(toPlan);
      showMessage("Plan updated successfully!", "success");
    } catch (err) {
      showMessage("Failed to change plan", "error");
    }
  };

  // ---------------- UI ----------------
  return (
    <Box sx={{ mt: 2, }}>
      <Typography variant="h2" gutterBottom sx={{ fontWeight: "bold", mb: 4 }}>
        {step === "selectPlan" && "Choose Your Subscription"}
        {step === "checkout" && "Checkout"}
        {step === "manage" && "Manage Your Subscription"}
      </Typography>

      {/* Step 1: Plan selection */}
      {step === "selectPlan" && (
        <Plans
          plan={plan}
          setPlan={setPlan}
          productList={productList}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          goToCheckout={() => setStep("checkout")}
        />

      )}

      {step === "checkout" && (
        <Checkout
          selectedProduct={selectedProduct}
          name={name}
          setName={setName}
          email={email}
          setEmail={setEmail}
          handleSubscribe={handleSubscribe}
          loading={loading}
          goBack={() => setStep("selectPlan")}
        />
      )}

      {step === "manage" && subscription && (
        <ManageSubscription
          subscription={subscription}
          products={productList}
          handleCancel={handleCancel}
          handleResume={handleResume}
          handleChangePlan={handleChangePlan}
          billingHistory={billingHistory}
          orgId={orgId}
          userDetails={userDetails}
        />
      )}

    </Box>
  );
}

export default SubscribeForm;
